// utils/projectAuthSession.js

const KEY = "ai4signs_project_auth";
const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

export function saveProjectAuth(user) {
  localStorage.setItem(
    KEY,
    JSON.stringify({
      userId: user.id || user.userId,
      email: user.email,
      status: user.status,
      expiresAt: Date.now() + SEVEN_DAYS
    })
  );
}

export function getProjectAuth() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;

  try {
    const session = JSON.parse(raw);

    if (!session.userId || !session.email || !session.expiresAt) {
      clearProjectAuth();
      return null;
    }

    if (Date.now() > session.expiresAt) {
      clearProjectAuth();
      return null;
    }

    return session;
  } catch {
    clearProjectAuth();
    return null;
  }
}

export function clearProjectAuth() {
  localStorage.removeItem(KEY);
}